<template>
  <div style="width: 98%; height: 98%">
<!--    顶部-->
    <div class="status-container">
      <el-row>
        <el-col :span="3" :offset="1" style="text-align: left;font-size: 18px;font-weight: bold; ">
          <el-form-item label="项目年份：">
            <el-date-picker v-model="project_year" type="years" value-format="YYYY" placeholder="选择年份" @change="getBusData" style="width: 100%"/>
          </el-form-item>
        </el-col>
        <el-col :span="4" :offset="1" style="text-align: left;font-size: 18px;font-weight: bold; ">
          <el-form-item label="项目名称：">
            <el-select v-model="project_id" placeholder="请选择" clearable @change="getBusData">
              <el-option v-for="item in projectList" :key="item.value" :label="item.label"
                         :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="3" :offset="1" style="text-align: left;font-size: 18px;font-weight: bold; ">
          <el-form-item label="项目状态：">
            <el-select v-model="project_status" placeholder="请选择" clearable @change="getBusData">
              <el-option v-for="item in projectStatusList" :key="item.value" :label="item.name"
                         :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="1" :offset="1" style="text-align: right;">
          <span class="color-block processed"></span>
        </el-col>
        <el-col :span="2" style="text-align: left;">
          <span class="status-text">已完成</span>
        </el-col>
        <el-col :span="1" style="text-align: right;">
          <span class="color-block pending"></span>
        </el-col>
        <el-col :span="2" style="text-align: left;">
          <span class="status-text">待处理</span>
        </el-col>
        <el-col :span="1" style="text-align: right;">
          <span class="color-block unclaimed"></span>
        </el-col>
        <el-col :span="2" style="text-align: left;">
          <span class="status-text">待领取</span>
        </el-col>
      </el-row>
    </div>
    <el-row style="margin-top: 10px;padding: 0 10px 0 10px">
      <el-col :span="24" style="width: 100%; height: 98%">
        <el-tabs v-model="activeName" type="border-card" @tab-change="handleClick" stretch >
          <el-tab-pane label="任务" name="task">
            <el-table :data="paginatedTaskList" style="width: 100%">
              <el-table-column prop="project_name" label="项目名称" min-width="150" />
              <el-table-column prop="name" label="任务名称" min-width="200" >
                <template #default="{ row }">
                  <span
                      style="cursor: pointer; color: #409EFF"
                      @click="openTaskDetailWindow(row)"
                  >{{ row.name }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column prop="status_name" label="任务状态" min-width="100"/>
              <el-table-column prop="plan_end_date" label="计划完成日期" min-width="100"/>
              <el-table-column prop="stage_name" label="所属阶段" min-width="100"/>
            </el-table>
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[5, 10, 15, 30]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="busData.task_list.length">
            </el-pagination>
          </el-tab-pane>
          <el-tab-pane label="需求" name="requirement">
            <el-table :data="paginatedRequirementList" style="width: 100%">
              <el-table-column prop="project_name" label="项目名称" min-width="150" />
              <el-table-column prop="title" label="需求名称" min-width="200" >
                <template #default="{ row }">
                  <span
                      style="cursor: pointer; color: #409EFF"
                      @click="openRequirementDetailWindow(row)"
                  >{{ row.title }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column prop="status_name" label="需求状态" min-width="100"/>
              <el-table-column prop="request_person" label="提出人" min-width="100"/>
              <el-table-column prop="request_date" label="提出日期" min-width="100"/>
            </el-table>
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[5, 10, 15, 30]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="busData.requirement_list.length">
            </el-pagination>
          </el-tab-pane>
          <el-tab-pane label="BUG" name="bug">
            <el-table :data="paginatedBugList" style="width: 100%">
              <el-table-column prop="project_name" label="项目名称" min-width="150"/>
              <el-table-column prop="title" label="BUG名称" min-width="200">
                <template #default="{ row }">
                  <span
                      style="cursor: pointer; color: #409EFF"
                      @click="openBugDetailWindow(row)"
                  >{{ row.title }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column prop="status_name" label="BUG状态" min-width="100"/>
              <el-table-column prop="request_person" label="提出人" min-width="100"/>
              <el-table-column prop="request_date" label="提出日期" min-width="100"/>
            </el-table>
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[5, 10, 15, 30]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="busData.bug_list.length">
            </el-pagination>
          </el-tab-pane>
          <el-tab-pane label="工单" name="issue">
            <el-table :data="paginatedIssueList" style="width: 100%">
              <el-table-column prop="project_name" label="项目名称" min-width="150" />
              <el-table-column prop="title" label="工单名称" min-width="200" >
                <template #default="{ row }">
                  <span
                      style="cursor: pointer; color: #409EFF"
                      @click="openIssueDetailWindow(row)"
                  >{{ row.title }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column prop="status_name" label="工单状态" min-width="100"/>
              <el-table-column prop="request_person" label="提出人" min-width="100"/>
              <el-table-column prop="request_date" label="提出日期" min-width="100"/>
            </el-table>
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[5, 10, 15, 30]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="busData.issue_list.length">
            </el-pagination>
          </el-tab-pane>
          <el-tab-pane label="风险" name="risk">
            <el-table :data="paginatedRiskList" style="width: 100%">
              <el-table-column prop="project_name" label="项目名称" min-width="150" />
              <el-table-column prop="title" label="风险名称" min-width="200" >
                <template #default="{ row }">
                  <span
                      style="cursor: pointer; color: #409EFF"
                      @click="openRiskDetailWindow(row)"
                  >{{ row.title }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column prop="status_name" label="风险状态" min-width="100"/>
              <el-table-column prop="request_person" label="提出人" min-width="100"/>
              <el-table-column prop="request_date" label="提出日期" min-width="100"/>
            </el-table>
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[5, 10, 15, 30]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="busData.risk_list.length">
            </el-pagination>
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" style="width: 100%;">
        <el-row style="padding-top: 10px;">
          <template v-for="data in busData.project_list">
            <el-col :span="12"
                    style="font-size: large; line-height: 50px;text-align: center;padding: 0 80px;width:100%;margin-bottom: 10px">
              <el-row class="project-name">
                <el-col :span="6" >{{ data.start_year }}</el-col>
                <el-col :span="12" style="text-align: center;">{{ data.project_name }}</el-col>
                <el-col :span="4" style="text-align: right;">{{ data.project_status_name }}</el-col>
              </el-row>
              <el-row v-for="item in data.item_list" style="width: 100%;">
                <el-col :span="6" class="val1">{{ item.name }}</el-col>
                <el-col :span="6" class="val2">{{ item.processed_cnt }}</el-col>
                <el-col :span="6" class="val3">{{ item.pending_cnt }}</el-col>
                <el-col :span="6" class="val5">{{ item.unclaimed_cnt }}</el-col>
              </el-row>
            </el-col>
          </template>
        </el-row>
      </el-col>
    </el-row>
  </div>

</template>

<script>

export default {
  name: "ProjectMine",

  data() {
    return {
      busData: {
        project_list: [],
        task_list: [],
        requirement_list: [],
        bug_list: [],
        issue_list: [],
        risk_list: [],
      },
      projectList: [],
      project_id: '',
      project_year: [],
      project_status: '',
      activeName: 'task',
      currentPage: 1, // 当前页码
      pageSize: 5,   // 每页显示的数据条数
    }
  },

  computed: {
    projectStatusList() {
      return this.$store.getters['core/getDictList']('project_status');
    },

    paginatedTaskList() {
      return this.busData.task_list.slice(
          (this.currentPage - 1) * this.pageSize,
          this.currentPage * this.pageSize
      )
    },

    paginatedRequirementList() {
      return this.busData.requirement_list.slice(
          (this.currentPage - 1) * this.pageSize,
          this.currentPage * this.pageSize
      )
    },

    paginatedBugList() {
      return this.busData.bug_list.slice(
          (this.currentPage - 1) * this.pageSize,
          this.currentPage * this.pageSize
      )
    },

    paginatedIssueList() {
      return this.busData.issue_list.slice(
          (this.currentPage - 1) * this.pageSize,
          this.currentPage * this.pageSize
      )
    },

    paginatedRiskList() {
      return this.busData.risk_list.slice(
          (this.currentPage - 1) * this.pageSize,
          this.currentPage * this.pageSize
      )
    },

  },

  created() {
    this.getBusData();
    this.getProjectList();
  },

  methods: {
    async getBusData() {
      let params = {
        project_year: this.project_year,
        project_id: this.project_id,
        project_status: this.project_status
      }
      this.busData = await this.$http('prjBoardService.getMyProjectBoard', params)
    },

    async getProjectList() {
      this.projectList = await this.$http('prjBoardService.getProjectList')
    },

    getProjectColor(status_name) {
      switch (status_name) {
        case '待领取':
          return 'rgba(220, 216, 14, 0.71)';
        case '待处理':
          return '#EA9C0BBA';
        default:
          return '#EA9C0BBA';
      }
    },

    handleClick(){
      this.handleSizeChange(this.pageSize)
    },

    // 每页条数改变时触发
    handleSizeChange(newSize) {
      this.pageSize = newSize
      this.currentPage = 1 // 重置到第一页
    },

    // 当前页码改变时触发
    handleCurrentChange(newPage) {
      this.currentPage = newPage
    },

    //点击任务名称跳转到详情页面
    openTaskDetailWindow(row){
      this.$store.dispatch('core/openWindow', {
        component: 'project/TaskDetail',
        name: row.name,
        parentData: row,
        max:true
      })
    },

    //点击bug标题跳转到详情页面
    openBugDetailWindow(row){
      this.$store.dispatch('core/openWindow', {
        component: 'project/BugDetail',
        name: row.title,
        parentData: row,
        max:true
      })
    },

    //点击需求标题跳转到详情页面
    openRequirementDetailWindow(row){
      this.$store.dispatch('core/openWindow', {
        component: 'project/RequirementDetail',
        name: row.title,
        parentData: row,
        max:true
      })
    },

    //点击工单标题跳转到详情页面
    openIssueDetailWindow(row){
      this.$store.dispatch('core/openWindow', {
        component: 'project/IssueDetail',
        name: row.title,
        parentData: row,
        max:true
      })
    },

    //点击风险标题跳转到详情页面
    openRiskDetailWindow(row){
      this.$store.dispatch('core/openWindow', {
        component: 'project/RiskDetail',
        name: row.title,
        parentData: row,
        max:true
      })
    },

  }

}

</script>

<style lang="less" scoped>

.project-name {
  margin-bottom: 5px;
  color: #fff;
  font-size: 22px; /* 文字更大 */
  background-color: rgba(112,110,110,0.65);
}

.val {
  margin-bottom: 5px;
  background-color: skyblue;
  color: #fff;
}

.val1 {
  margin-bottom: 5px;
  background-color: skyblue;
  color: #fff;
}

.val2 {
  margin-bottom: 5px;
  background-color: rgba(13, 213, 46, 0.55);
  color: #fff;
}

.val3 {
  margin-bottom: 5px;
  background-color: #EA9C0BBA;
  color: #fff;
}

.val4 {
  margin-bottom: 5px;
  background-color: #FC02029D;
  color: #fff;
}

.val5 {
  margin-bottom: 5px;
  background-color: rgba(220, 216, 14, 0.71);
  color: #fff;
}

.status-container {
  padding-top: 20px; /* 增加内边距 */
  background-color: #f5f5f5; /* 背景色 */
  border-bottom: 1px solid #ddd; /* 底部边框 */
  position: sticky; /* 固定在页面顶部 */
  top: 0; /* 距离顶部为 0 */
  z-index: 100; /* 确保在最上层 */
}

.color-block {
  display: inline-block;
  width: 100%; /* 色块宽度 */
  height: 30px; /* 色块高度 */
  border-radius: 6px; /* 圆角 */
}

.processed {
  background-color: rgba(13, 213, 46, 0.55); /* 绿色 */
}

.pending {
  background-color: #EA9C0BBA; /* 橙色 */
}

.unclaimed {
  background-color: rgba(220, 216, 14, 0.71); /* 黄色 */
}

.status-text {
  font-size: 18px; /* 文字更大 */
  font-weight: bold; /* 文字加粗 */
  color: #333; /* 文字颜色 */
  width: 80%; /* 文字宽度与色块一致 */
  text-align: left; /* 文字居中 */
  margin-left: 10px;
}

:deep(.el-tabs__item) {
  font-size: 18px;
  font-weight: bold;
}

</style>